import React from 'react';
import $ from 'jquery';
import LoggedInPage from '../../views/core/LoggedInPage';
import HmAjax from '../../util/HmAjax';
import sidebar_props from '../../model/AppConstants.js';
import UserStorageUtil from '../../util/UserStorageUtil';
import heymathlogo from '../../images/heymathlogo.png';

class Header extends LoggedInPage {
	
  constructor(props) {
  	 super(props);
  }
  
  componentDidMount(){
  		try{
  			var isCollapsed = (this.getAttribute("sidebar_collapsed") === "true");

  			//UserStorageUtil.getStoredSessionItem("sidebar_collapsed") ||
			sidebar_props.collapsed = isCollapsed ||  sidebar_props.collapsed;

			if(sidebar_props.collapsed === true){
				$('.side-navbar').addClass('shrinked');
				$('.content-inner').addClass('active');
				$('#toggle-btn').removeClass('active');
				$('#toggle-btn').removeClass("goRight");
				$('.navbar-header .brand-small').show();
                $('.navbar-header .brand-big').hide();
			}
		}catch(e){
			console.error(e);
		}

  		if ($(window).outerWidth() > 1183) {
			if ($('#toggle-btn').hasClass('active')) {             
				$('#toggle-btn').addClass("goRight");
			} else {             
				$('#toggle-btn').removeClass("goRight");
			}
		}
		if ($(window).outerWidth() < 1183) {         
			$('#toggle-btn').removeClass("goRight");
		}
	}

  toggleSideBar(){
	  $('#toggle-btn').toggleClass('active');

        $('.side-navbar').toggleClass('shrinked');
        $('.content-inner').toggleClass('active');
        if ($(window).outerWidth() > 1183) {
            if ($('#toggle-btn').hasClass('active')) {
                $('.navbar-header .brand-small').hide();
                $('.navbar-header .brand-big').show();
                $('#toggle-btn').addClass("goRight");
            } else {
                $('.navbar-header .brand-small').show();
                $('.navbar-header .brand-big').hide();
                $('#toggle-btn').removeClass("goRight");
            }
        }

        if ($(window).outerWidth() < 1183) {
            $('.navbar-header .brand-small').show();
            $('#toggle-btn').removeClass("goRight");
        }

        try{
        	var isCollapsed = $('.side-navbar').hasClass('shrinked');


        	if(typeof isCollapsed === "boolean"){
        		this.setAttribute("sidebar_collapsed",isCollapsed.toString());	
        	}
        	

        	sidebar_props.collapsed =  $('.side-navbar').hasClass('shrinked');
        	UserStorageUtil.storeSessionItem("sidebar_collapsed",sidebar_props.collapsed);
        }catch(e){
        	console.log(e);
        }
  }

  onLogout(){
	  var me = this;
	   var msg = me.rb("logout.msg");
	   var buttons = [{
                label: me.rb("alert.ok"),
                handler: () => { me.doLogout() }
            },
            {
                label: me.rb("alert.cancel"),
                handler: () => { }
            }]

        me.showAlert(" ", msg, buttons);
  }
  doLogout(){
  	var me = this;
  	var callBackSuccess = function(){
  		
		me.initiateTrack("logout",{});
  		
  		setTimeout(function(){
  			me.getUser().clearOldUser();
  	  		window.location.href = me.getUrlFor("PRELOGIN_PAGE");
  		},500)
  		
  	}

  	var callBackFailure = function(){
  		console.error("Logout failed.");
  	}
  	
  	new HmAjax(me.getUrlFor("LOGOUT")).get(callBackSuccess,callBackFailure);
  }
  
  render() {
    return (
		<header className="header">
			<nav className="navbar bg-purple">
			 
			  <div className="container-fluid">
				<div className="navbar-holder d-flex align-items-center justify-content-between">
				  
				  <div className="navbar-header">
					<a href={this.getUrlFor("PRELOGIN_PAGE")} className="navbar-brand">
					  <div className="brand-text brand-big"><img src={heymathlogo} className="heymathlogo" width="100"/></div>
					  <div className="brand-text brand-small"><strong>H!</strong></div>
					</a>
					<a id="toggle-btn" href="#" className="menu-btn active" onClick={() => {this.toggleSideBar()}}><span></span><span></span><span></span></a>
				  </div>
				  
				  
				  <ul className="nav-menu list-unstyled d-flex flex-md-row align-items-md-center">               
				   
					<li className="nav-item dropdown"> <a id="notifications" rel="nofollow" data-target="#" href="#" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" className="nav-link"><i className="material-icons md-40">account_circle</i></a>
					  <ul aria-labelledby="notifications" className="dropdown-menu">
						<li><a rel="nofollow" href="/myproducts" className="dropdown-item"> 
							<div className="notification">
							  <div className="notification-content">{this.rb("product.mypurchases")}</div>
							</div></a></li>
						<li><a rel="nofollow" href="/settings" className="dropdown-item"> 
							<div className="notification">
							  <div className="notification-content">My Profile</div>
							</div></a></li>
						<li><a rel="nofollow" href="#" className="dropdown-item" onClick={() => {this.onLogout()}}> 
							<div className="notification">
							  <div className="notification-content">Signout</div>
							</div></a></li>
						
					  </ul>
					</li>
					
					
					{/*<li className="nav-item"><a href="#" onClick={() => {this.onLogout()}} className="nav-link logout"><i className="material-icons">power_settings_new</i></a></li>*/}
				  </ul>
				</div>
			  </div>
			</nav>
		  </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/views/common/Header.js